import config from "../config";
import { SuiteInitialConfiguration,NeedInitialConfiguration } from "../Model/InitialConfiguration";
import { sendPostRequest, sendGetRequest, sendPutRequest } from "../Utility/FetchUtils";
import { InstrumentsInfo } from "../Model/InstrumentsInfo"; 

class InitialConfigurationApi{
    static BASE_URL = config.SERVICE_URL + "/InitialConfiguration";

    static getCurrentConfiguration(){
        const url = InitialConfigurationApi.BASE_URL +"/:current"
        return sendGetRequest<SuiteInitialConfiguration>(url);
    }
    static getLastConfigurationError(){
        const url = InitialConfigurationApi.BASE_URL +"/:last-error"
        return sendGetRequest<{[index: string]: string}>(url);
    }
    static getIsNeedInitialConfiguration(){
         const url = InitialConfigurationApi.BASE_URL +"/:is-required"
         return sendGetRequest<NeedInitialConfiguration>(url);
    }
    static getInstrumentsInfo(){
        const url = InitialConfigurationApi.BASE_URL + "/:instruments-info"
        return sendGetRequest<InstrumentsInfo>(url);
    }
    static setCurrentConfiguration(force:boolean, suiteConfiguration: SuiteInitialConfiguration ){
        const url = InitialConfigurationApi.BASE_URL +"/"+force
        return sendPutRequest(url,suiteConfiguration)
    }
    static setIsNeedInitialConfiguration(needInitialConfiguration: NeedInitialConfiguration ){
        const url = InitialConfigurationApi.BASE_URL +"/:set-required"
        return sendPutRequest(url,needInitialConfiguration)
    }
}

export default InitialConfigurationApi;